(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensur-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('.smx');
    if(!root)return;
    var mainImg=root.querySelector('#sm-main-img');
    var mainWrap=root.querySelector('.sm-main');
    var price=root.querySelector('#sm-price');
    var btnPrice=root.querySelector('#sm-btnprice');
    var vid=root.querySelector('#sm-variant-id');
    var qtyEl=root.querySelector('#sm-qty');
    var vopts=root.querySelectorAll('.sm-vopt');

    if(mainImg){
      mainImg.addEventListener('error',function(){ if(mainWrap) mainWrap.classList.add('sm-empty'); });
      mainImg.addEventListener('load',function(){ if(mainWrap) mainWrap.classList.remove('sm-empty'); });
    }
    function selVariant(btn){
      if(btn.hasAttribute('disabled'))return;
      if(vid) vid.value=btn.getAttribute('data-id');
      var p=btn.getAttribute('data-price');
      if(price&&p) price.innerHTML=p;
      if(btnPrice&&p) btnPrice.innerHTML=p;
      var img=btn.getAttribute('data-img');
      if(img&&mainImg){ mainWrap.classList.remove('sm-empty'); mainImg.src=img; }
      root.style.setProperty('--acc',btn.getAttribute('data-accent'));
      root.style.setProperty('--soft',btn.getAttribute('data-soft'));
      for(var i=0;i<vopts.length;i++){ vopts[i].setAttribute('aria-pressed', vopts[i]===btn?'true':'false'); }
    }
    for(var i=0;i<vopts.length;i++){ vopts[i].addEventListener('click',(function(b){return function(){selVariant(b);};})(vopts[i])); }

    var thumbs=root.querySelectorAll('.sm-thumb');
    for(var t=0;t<thumbs.length;t++){
      thumbs[t].addEventListener('click',(function(el){return function(){ var i=el.getAttribute('data-img'); if(i&&mainImg){ mainWrap.classList.remove('sm-empty'); mainImg.src=i; } };})(thumbs[t]));
    }
    var inc=root.querySelector('[data-q="inc"]'), dec=root.querySelector('[data-q="dec"]');
    if(inc) inc.addEventListener('click',function(){ qtyEl.value=Math.min(99,(parseInt(qtyEl.value,10)||1)+1); });
    if(dec) dec.addEventListener('click',function(){ qtyEl.value=Math.max(1,(parseInt(qtyEl.value,10)||1)-1); });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();

  } catch(e) { console.error(e); }
})();
})();
